import { primaryGreen, secondeGreen } from "../../utils/colors";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <div
      className="flex items-center justify-center min-h-screen bg-gray-50"
      style={{ direction: "rtl" }}
    >
      <div className="max-w-md p-8 bg-white rounded-lg shadow-xl text-center">
        {/* آیکون یا لوگو */}
        <div className="mb-6">
          <svg
            className="w-24 h-24 mx-auto"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ color: primaryGreen }}
          >
            <path
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 8V12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 16H12.01"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* عنوان و متن خطا */}
        <h1 className="text-5xl font-bold mb-4" style={{ color: primaryGreen }}>
          ۴۰۴
        </h1>
        <h2
          className="text-2xl font-semibold mb-4"
          style={{ color: secondeGreen }}
        >
          صفحه مورد نظر یافت نشد
        </h2>
        <p className="text-gray-600 mb-6">
          متأسفیم، صفحه‌ای که به دنبال آن هستید وجود ندارد یا ممکن است حذف شده
          باشد.
        </p>
        <button
          onClick={() => navigate("/")}
          className="inline-block px-6 py-3 rounded-lg font-medium transition-colors duration-200"
          style={{
            backgroundColor: primaryGreen,
            color: "white",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = secondeGreen)}
          onMouseLeave={(e) => (e.target.style.backgroundColor = primaryGreen)}
        >
          بازگشت به صفحه اصلی
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
